const URL_TOKEN = 'urlToken';
const TOKEN_KEY = 'authToken';
const DEBTOR_ID_KEY = 'debtorId';
const DEBTOR_NAME_KEY = 'debtorName';
const IS_INTERNAL_KEY = 'isInternal';
const COMPANY_ID_KEY = 'companyId';

export const saveUrlToken = (token: string) => {
    sessionStorage.setItem(URL_TOKEN, token);
};

export const saveToken = (token: string) => {
    sessionStorage.setItem(TOKEN_KEY, token);
};

export const saveDebtorId = (debtorId: number) => {
    sessionStorage.setItem(DEBTOR_ID_KEY, String(debtorId));
};

export const saveCompanyId = (companyId: number) => {
    sessionStorage.setItem(COMPANY_ID_KEY,String(companyId));
}

export const readSavedDebtorId = (): number | null => {
    const stored = sessionStorage.getItem(DEBTOR_ID_KEY);
    if (stored === null) return null;
    const parsed = Number(stored);
    return Number.isNaN(parsed) ? null : parsed;
};

export const readSavedCompanyId = ():number | null => {
    const storedCompanyID = sessionStorage.getItem(COMPANY_ID_KEY);
    if(storedCompanyID === null) return null;
    const parsedCompanyId = Number(storedCompanyID);
    return Number.isNaN(parsedCompanyId) ? null : parsedCompanyId;
}

export const saveDebtorName = (name: string) => {
    sessionStorage.setItem(DEBTOR_NAME_KEY, name);
};

export const readSavedDebtorName = (): string | null => {
    return sessionStorage.getItem(DEBTOR_NAME_KEY);
};

export const clearDebtorName = () => {
    sessionStorage.removeItem(DEBTOR_NAME_KEY);
};

export const readSavedUrlToken = () => {
    const storedToken = sessionStorage.getItem(URL_TOKEN);
    return storedToken;
};

export const readSavedToken = () => {
    const storedToken = sessionStorage.getItem(TOKEN_KEY);
    return storedToken;
};

export const clearToken = () => {
    sessionStorage.removeItem(TOKEN_KEY);
};

export const clearSessionStorage = () => {
    const v2Enabled = sessionStorage.getItem(BR_V2_ENABLED_KEY);
    sessionStorage.clear();
    if (v2Enabled !== null) sessionStorage.setItem(BR_V2_ENABLED_KEY, v2Enabled);
};

export const clearSessionStorageOnCompletion = () => {
    sessionStorage.clear();
};

const BR_V2_ENABLED_KEY = 'brV2Enabled';

export const saveV2Enabled = (v2Enabled: boolean) => {
    sessionStorage.setItem(BR_V2_ENABLED_KEY, String(v2Enabled));
};

export const readV2Enabled = (): boolean => {
    return sessionStorage.getItem(BR_V2_ENABLED_KEY) === 'true';
};

export const saveIsInternal = (isInternal: boolean) => {
    sessionStorage.setItem(IS_INTERNAL_KEY, String(isInternal));
};

export const readIsInternal = (): boolean | null => {
    const stored = sessionStorage.getItem(IS_INTERNAL_KEY);
    if (stored === null) return null;
    return stored === 'true';
};

export const clearDebtorId = () => {
    sessionStorage.removeItem(DEBTOR_ID_KEY);
    sessionStorage.removeItem(DEBTOR_NAME_KEY);
};

export const clearCompanyId = () => {
    sessionStorage.removeItem(COMPANY_ID_KEY);
}